import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import { Observable } from 'rxjs';
import {environment} from "../../environments/environment";
import {Page} from "../interface/hashtag";
import {ReservedQrsResponse} from "../interface/reservedQrResponse";
import {ReservedQrsConnectRequest} from "../models/ReservedQrsConnectRequest";

@Injectable({
  providedIn: 'root'
})
export class ReservedQrsService {

  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {
  }

  generateQrCode(qty: number): Observable<ReservedQrsResponse[]> {
    const params = new HttpParams()
      .set('qty', qty.toString());

    return this.http.get<ReservedQrsResponse[]>(`${this.apiUrl}/reserved-qrs/generate`,
      {params: params});
  }

  getAllQrCodes(page: number, size: number, status?: string): Observable<Page<ReservedQrsResponse>> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());

    if (status) {
      params = params.set('status', status);
    }

    return this.http.get<Page<ReservedQrsResponse>>(`${this.apiUrl}/reserved-qrs`, { params });
  }

  getByReservedIdentificationId(reservedIdentificationId: string): Observable<ReservedQrsResponse> {
    return this.http.get<ReservedQrsResponse>(`${this.apiUrl}/reserved-qrs/${reservedIdentificationId}`);
  }

  connectNewReservedQr(request: ReservedQrsConnectRequest): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/reserved-qrs/connect`, request);
  }
}
